import {
    policyTipsMultipleRecipientsViolationInfo,
    policyTipsSingleRecipientViolationInfo,
    policyTipsRemoveAllLink,
    policyTipsRemoveRecipientLink,
} from './PolicyTipsDetailsRecipient.locstring.json';
import loc from 'owa-localize';
import * as React from 'react';
import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import { InfoBarMessageWithCustomAction } from 'owa-info-bar-view';

export interface PolicyTipsDetailRecipientProps {
    onRecipientRemoveClick: (recipients: EmailAddressWrapper[]) => void;
    emailAddresses: EmailAddressWrapper[];
    classNameForLink?: string;
}

export const PolicyTipsDetailsRecipient = (props: PolicyTipsDetailRecipientProps) => {
    return (
        <>
            <span>
                {props.emailAddresses.reduce((accumulator, currentValue, currentIndex, array) => {
                    return currentValue
                        ? accumulator +
                              currentValue.Name +
                              (currentIndex == array.length - 1 ? ': ' : ', ')
                        : accumulator;
                }, '')}
            </span>
            <span>
                {props.emailAddresses.length > 1
                    ? loc(policyTipsMultipleRecipientsViolationInfo)
                    : loc(policyTipsSingleRecipientViolationInfo)}
            </span>
            {' ' /* This space preserves spacing between the message and the link. */}
            <InfoBarMessageWithCustomAction
                customAction={{
                    text:
                        props.emailAddresses.length > 1
                            ? loc(policyTipsRemoveAllLink)
                            : loc(policyTipsRemoveRecipientLink),
                    action: () => {
                        props.onRecipientRemoveClick(props.emailAddresses);
                    },
                }}
                className={props.classNameForLink}
            />
        </>
    );
};
